module.exports = __webpack_public_path__ + "static/media/enlarger_bottom.6f61b2bb.jpg";